<mat-form-field appearance="fill" class="fitWidth">
    <mat-label>
      <sc-dictionary-label [dictionaryKey]="transportOption.parameterNameDictionaryKey"></sc-dictionary-label>
    </mat-label>
    <input matInput [required]="true" [disabled]="true" [value]="valueString">
    <button mat-icon-button matSuffix (click)="showSelectionDialog()"><mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon></button>
</mat-form-field>
